import details from './details'
import trx from './trx'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    details.state,
    trx.state,
  ),
  mutations: Object.assign(
    details.mutations,
    trx.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/flight-details/index.js